// extracted by mini-css-extract-plugin
module.exports = {"info":"Dashboard_info__34kZ5","helloLabel":"Dashboard_helloLabel__YM-dM","countNumber":"Dashboard_countNumber__YWKrS"};